import React from "react";
import { Container, Stack, Tabs, Title } from "@mantine/core";
import { useSearchParams } from "react-router-dom";
import ProductConfigList from "./ProductConfigList";
import ProductsList from "./ProductsList";
import ProductVersionDistribution from "./ProductVersionDistribution";
import ScopeDistribution from "./ScopeDistribution";

const TABS = ["products", "configs", "distribution"] as const;
type TabValue = (typeof TABS)[number];

const ProductManagement: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: TabValue = TABS.includes(tabParam as TabValue)
    ? (tabParam as TabValue)
    : TABS[0];

  return (
    <Container size="lg" pb={120}>
      <Title order={2} my="md">
        Product Management
      </Title>

      <Tabs
        value={activeTab}
        onChange={(value) => value && setSearchParams({ tab: value }, { replace: true })}
        keepMounted={false}
      >
        <Tabs.List mb="md">
          <Tabs.Tab value="products">Products</Tabs.Tab>
          <Tabs.Tab value="configs">Product Configs</Tabs.Tab>
          <Tabs.Tab value="distribution">Distribution</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="products">
          <ProductsList />
        </Tabs.Panel>

        <Tabs.Panel value="configs">
          <ProductConfigList />
        </Tabs.Panel>

        <Tabs.Panel value="distribution">
          <Stack gap="md">
            <ProductVersionDistribution />
            <ScopeDistribution />
          </Stack>
        </Tabs.Panel>
      </Tabs>
    </Container>
  );
};

export default ProductManagement;
